export default {
  selectLanguage: "id",
  language: "ID",
  download_invoice: "UNDUH INVOICE",
  invoice_status_waiting_payment: "Menunggu Pembayaran",
  invoice_status_paid: "Sudah Dibayar",
  invoice_status_overdue: "Terlambat",

  invoice_number: "Nomor Invoice",
  invoice_date: "Tanggal Invoice",
  invoice_due_date: "Tanggal Jatuh Tempo",

  invoice_from: "Invoice Dari",
  invoice_to: "Invoice Kepada",

  product: "Produk",
  amount: "Jumlah",
  total_summary: "Ringkasan Total",
  summary: "Ringkasan",
  subtotal: "Subtotal",
  total_discount: "Total Diskon",
  additional_discount: "Diskon Tambahan",
  additional_fee: "Biaya Tambahan",
  delivery_fee: "Biaya Pengiriman",
  admin_fee: "Biaya Admin",
  tax: "Pajak",
  total: "Total",
  tax_included: "Pajak Termasuk",
  total_paid: "Total Bayar",
  amount_due: "Jumlah Yang Harus Dibayar",
  discount: "Diskon",

  signature: "Tanda Tangan",

  notes_terms: "Catatan & Kondisi",
  notes: "Catatan",
  terms_condition: "Syarat & Kondisi",

  view_payment: "Lihat Pembayaran",
  error_title: "Terjadi Kesalahan",
  error_description: "Terjadi kesalahan. Silakan coba lagi.",
  refresh: "Diperbarui",

  table_product: "Produk",
  table_description: "Deskripsi",
  table_qty: "Jumlah",
  table_price: "Harga (Rp)",
  table_discount: "Diskon",
  table_tax: "Pajak",
  table_amount: "Jumlah (Rp)",

  materai_info:
    "e-Materai sudah terlampir dan akan terlihat saat Anda mengunduh PDF invoice",
};
